import { render, staticRenderFns } from "./distributorWithdrawStatList.vue?vue&type=template&id=412f0ae9&scoped=true&"
import script from "./distributorWithdrawStatList.vue?vue&type=script&lang=js&"
export * from "./distributorWithdrawStatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412f0ae9",
  null
  
)

export default component.exports